import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { Card } from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface UptimeHeatmapProps {
  data: { date: string; score: number }[]
}

export function UptimeHeatmap({ data }: UptimeHeatmapProps) {
  return (
    <Card className="p-6 bg-slate-900/50 border-slate-800 backdrop-blur-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-white">System Availability</h3>
          <p className="text-sm text-slate-400">30-day performance heatmap</p>
        </div>
        <div className="flex items-center gap-2 text-xs">
          <span className="text-slate-500">Outage</span>
          <div className="flex gap-1">
            <div className="size-3 bg-rose-500 rounded-sm" />
            <div className="size-3 bg-amber-500 rounded-sm" />
            <div className="size-3 bg-emerald-500 rounded-sm" />
          </div>
          <span className="text-slate-500">Operational</span>
        </div>
      </div>
      <div className="grid grid-cols-[repeat(10,1fr)] sm:grid-cols-[repeat(15,1fr)] md:grid-cols-[repeat(30,1fr)] gap-1.5">
        <TooltipProvider>
          {data.map((day) => (
            <Tooltip key={day.date}>
              <TooltipTrigger asChild>
                <div
                  className={cn(
                    'aspect-square rounded-sm cursor-help transition-all hover:ring-2 hover:ring-white/20',
                    day.score >= 99
                      ? 'bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.2)]'
                      : day.score >= 95
                        ? 'bg-amber-500 shadow-[0_0_8px_rgba(245,158,11,0.2)]'
                        : 'bg-rose-500 shadow-[0_0_8px_rgba(244,63,94,0.2)]',
                  )}
                />
              </TooltipTrigger>
              <TooltipContent className="bg-slate-950 border-slate-800 text-white p-2">
                <div className="text-xs space-y-1">
                  <p className="font-bold">
                    {new Date(day.date).toLocaleDateString('en', {
                      month: 'long',
                      day: 'numeric',
                      year: 'numeric',
                    })}
                  </p>
                  <p className="text-slate-400">Availability: {day.score.toFixed(2)}%</p>
                </div>
              </TooltipContent>
            </Tooltip>
          ))}
        </TooltipProvider>
      </div>
      <div className="mt-4 flex justify-between text-[10px] text-slate-500 uppercase font-mono tracking-widest">
        <span>30 Days Ago</span>
        <span>Today</span>
      </div>
    </Card>
  )
}
